if (typeof BirdieBundle === "undefined") {
    class BirdieBundle extends HTMLElement {
    constructor() {
      super();
    }
    
      connectedCallback() {
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer")
        this.step = 1;
        this.activeBundleCount = 5;
        this.bundleOptions = this.querySelectorAll(".bundle-option");
        this.step1 = this.querySelector(".js-step-1");
        this.step2 = this.querySelector(".js-step-2");
        this.selectedColorsContainer = this.querySelector(
          ".js-selected-bundle-options"
        );
        this.selectedColorsHeader = this.querySelector(
          ".js-selected-bundle-options_header"
        );
        this.selectedColors = [];
    
        this.bundleOptions.forEach((bundle) => {
          bundle.addEventListener("click", (event) => {
            this.setActiveBundle(event.currentTarget.dataset.idx);
          });
        });
    
        this.querySelector(".js-add-bundle-to-cart").addEventListener(
          "click",
          () => {
            this.addBundleToCart();
            this.setStep(1);
          }
        );
    
        this.querySelectorAll(".color-option").forEach((el) => {
          el.addEventListener("click", (event) => {
            console.log(event.currentTarget.dataset);
            this.addColor(event.currentTarget.dataset);
          });
        });
    
        this.querySelector(".js-next-step").addEventListener("click", (event) => {
          this.setStep(2);
        });
        this.querySelector(".js-back-step").addEventListener("click", (event) => {
          this.setStep(1);
        });
      }
  
    setStep(step) {
      if (this.step === step) return;
      if (step === 1) {
        this.parentElement.parentElement.querySelector("variant-radios").style.display = "block";
        this.step1.classList.remove("hidden");
        this.step2.classList.add("hidden");
        this.selectedColors = [];
        this.bundleIncomplete();
      } else if (step === 2) {
        this.parentElement.parentElement.querySelector("variant-radios").style.display = "none";
        this.step1.classList.add("hidden");
        this.step2.classList.remove("hidden");
        this.buildSelectedColors();
      }
      this.step = step;
    }
  
    setActiveBundle(idx) {
      this.bundleOptions.forEach((el) => {
        el.classList.remove("active");
      });
      this.bundleOptions[idx].classList.add("active");
      this.activeBundleCount = Number(this.bundleOptions[idx].dataset.bundleSize);
    }
  
    buildSelectedColors() {
      this.selectedColorsHeader.innerHTML = "";
      this.selectedColorsContainer.innerHTML = "";
      for (let i = 0; i < this.activeBundleCount; i++) {
        this.selectedColorsContainer.insertAdjacentHTML(
          "beforeend",
          `${
            this.selectedColors[i]
              ? `<div class="selected-color selected"><button data-idx=${i} class="js-remove-color bundle-remove-color">X</button><div class="selected-color_img"><img src=${this.selectedColors[i].imgSrc}/></div><div>${this.selectedColors[i].title}</div></div>`
              : `<div class="selected-color"><div class="selected-color_img"><div></div></div><div>Birdie #${
                  i + 1
                }</div></div>`
          }`
        );
      }
  
      // add event listeners to remove color
      this.querySelectorAll(".js-remove-color").forEach((el) => {
        el.addEventListener("click", (event) => {
          this.selectedColors.splice(event.currentTarget.dataset.idx, 1);
          this.bundleIncomplete();
          this.buildSelectedColors();
        });
      });

      if (window.codeCookie === 'BFCM-VIP') {
        this.selectedColorsHeader.innerHTML = `
          <div>
            Your ${this.activeBundleCount}-pack includes:
          </div>
          <div class="bundle-header-prices">
              <div class="bundle-option_compare-price">$${
                (34.95 * this.activeBundleCount).toFixed(2)
              }</div>
              <div class="bundle-option_real-price">
              ${this.activeBundleCount === 5 ? "$104.85" : ""}
                ${this.activeBundleCount === 3 ? "$78.63" : ""}
                ${this.activeBundleCount === 1 ? "$29.71" : ""}
              </div>
                  
          </div>`;
      } else {
        this.selectedColorsHeader.innerHTML = `
          <div>
            Your ${this.activeBundleCount}-pack includes:
          </div>
          <div class="bundle-header-prices">
              <div class="bundle-option_compare-price">$${
                (34.95 * this.activeBundleCount).toFixed(2)
              }</div>
              <div class="bundle-option_real-price">
                ${this.activeBundleCount === 5 ? "$104.85" : ""}
                ${this.activeBundleCount === 3 ? "$78.64" : ""}
                ${this.activeBundleCount === 1 ? "$29.71" : ""}
              </div>
                  
          </div>`;
        
      }
  
    }
  
    bundleComplete() {
      this.querySelector(".color-options").style.display = "none";
      this.querySelector(".js-add-bundle-to-cart").disabled = false;
    }
  
    bundleIncomplete() {
      this.querySelector(".color-options").style.display = "flex";
      this.querySelector(".js-add-bundle-to-cart").disabled = true;
    }
  
    addBundleToCart() {
      const sectionRender = this.cart
        .getSectionsToRender()
        .map((section) => section.id);
  
      let variantQuantities = {};
      
      this.selectedColors.forEach(({ id }) => {
        variantQuantities[id] = variantQuantities[id]
          ? variantQuantities[id] + 1
          : 1;
      });
      
      let formItems = Object.keys(variantQuantities).map((variantId) => {
        console.log('variantId')
        console.log(variantId)
        if (window.codeCookie === 'BFCM-VIP') {
          console.log('code cookie is here')
          return {
            id: variantId,
            quantity: variantQuantities[variantId],
            properties: {
              _BFCMVIP: 'true'
            }
          }
        } else {
          console.log('NO COOKIE')
          return {
            id: variantId,
            quantity: variantQuantities[variantId],
            properties: {
              '_theme': 'med'
            }
          }
        }
      });

      let carePlanAdded = false;
      if (document.querySelector('cart-drawer-items')) {
        document.querySelectorAll('.cart-item').forEach(item => {
          if (item.dataset.title === 'Birdie Care Plan') {
            carePlanAdded = true;
          }
        })
      }

      

      let carePlanSKU = {}
      
      if (!carePlanAdded) {
        if (window.pv === 'v1') {
          // add increased price birdie
          carePlanSKU = {
            id: '43653782798511',
            quantity: 1
          };
        } else if (window.pv === 'v2') {
          carePlanSKU = {
            id: '44371628359855',
            quantity: 1
          };
          
        } else if (window.pv === 'v3') {
          carePlanSKU = {
            id: '44423581401263',
            quantity: 1
          };
          
        } else if (window.pv === 'v4') {
          carePlanSKU = {
            id: '44423590183087',
            quantity: 1
          };
          
        } else if (window.pv === 'v5') {
          carePlanSKU = {
            id: '44423591657647',
            quantity: 1
          };            
        } else {
          carePlanSKU = {
            id: '43653782798511',
            quantity: 1
          };
        }
        
        if (window.warrantyActive) {
          formItems.push(carePlanSKU)  
        }
      }
  
  
      let formData = {
        items: formItems,
        sections: sectionRender,
        sections_url: window.location.pathname,
      };
  
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.log(response.status);
          }
          console.log(response)
  
          this.cart.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          // this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains("is-empty"))
            this.cart.classList.remove("is-empty");
          // if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }
  
    addColor({ title, imgsrc, id }) {
      if (this.selectedColors.length === this.activeBundleCount) {
        return;
      }
  
      this.selectedColors.push({ title: title, imgSrc: imgsrc, id: id });
      if (this.selectedColors.length === this.activeBundleCount) {
        this.bundleComplete();
      } else {
        this.bundleIncomplete();
      }
      this.buildSelectedColors();
    }
  }
  
  if (!customElements.get('birdie-bundle')) {
    customElements.define("birdie-bundle", BirdieBundle);
  }

}